import { render, staticRenderFns } from "./ProdcutsCheckoutComponent.vue?vue&type=template&id=6c496a8b"
import script from "./ProdcutsCheckoutComponent.vue?vue&type=script&lang=js"
export * from "./ProdcutsCheckoutComponent.vue?vue&type=script&lang=js"
import style0 from "./ProdcutsCheckoutComponent.vue?vue&type=style&index=0&id=6c496a8b&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports